import 'react-responsive-carousel/lib/styles/carousel.min.css'
import { Carousel } from 'react-responsive-carousel'
import { Paper } from '@mui/material'
import _ from 'lodash'

const TipCarousel = () => {
  const height = 80
  const itemStyle = {
    backgroundColor: '#3335',
    height,
    padding: '1px 20px',
    display: 'flex',
    alignItems: 'center',
  }

  const tips = _.shuffle([
    '😌 Keep most of your targets easy, and just stretch yourself on one.',
    `🏝 Set easier weekend targets, like, "M-F Workout, yoga on Saturday".`,
    `🎉 Start the day with an easy win! Like, "Meditate for 5 minutes".`,
    `🐸 Make your main priority something you need some extra accountability on.`,
    `🥗 Make it actionable: "Eat a salad daily" vs "Don't eat junk food"`,
  ])

  return (
    <Paper elevation={4} style={{ maxHeight: height, marginBottom: 15 }}>
      <Carousel dynamicHeight={false} showStatus={false} showIndicators={false}>
        {tips.map((text, index) => (
          <div style={itemStyle} key={index}>
            <p>{text}</p>
          </div>
        ))}
      </Carousel>
    </Paper>
  )
}

export default TipCarousel
